import styled from 'styled-components'
import { textSize } from './Text'

export const FieldError = styled.div`
  ${textSize('pxs')};
  color: var(--error-red);
  margin-top: 4px;
  text-transform: none;
`
